import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AdminShell, SECTIONS } from "@/components/admin/AdminShell";
import { DashboardHome } from "@/components/admin/DashboardHome";
import { CoachingPanel } from "@/components/admin/CoachingPanel";
import { ClientsPanel } from "@/components/admin/ClientsPanel";
import { OrdersPanel } from "@/components/admin/OrdersPanel";
import { ProductsPanel } from "@/components/admin/ProductsPanel";
import { AppAccessPanel } from "@/components/admin/AppAccessPanel";
import { SettingsPanel } from "@/components/admin/SettingsPanel";
import { SoftSkillsPanel } from "@/components/admin/SoftSkillsPanel";

const PANELS = {
  dashboard: DashboardHome, contatti: CoachingPanel, clienti: ClientsPanel, checkup: SoftSkillsPanel, ordini: OrdersPanel,
  prodotti: ProductsPanel, accessi: AppAccessPanel, impostazioni: SettingsPanel,
};

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const { section = "dashboard" } = useParams();

  if (user === null) return <div className="grid min-h-screen place-items-center font-mono text-sm text-[#a3b1aa]">Caricamento…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;
  if (!PANELS[section]) return <Navigate to="/admin/dashboard" replace />;

  const Panel = PANELS[section];
  const title = SECTIONS.find(([k]) => k === section)?.[1] ?? "Back office";
  return (
    <AdminShell current={section} title={title} onLogout={logout}>
      <Panel />
    </AdminShell>
  );
}
